
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"48","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.01 10.434l17.514 8.408 4.326 18.892-12.12 15.15H22.29l-12.12-15.15 4.326-18.892z","fill":"#c2b9da"}}),_c('g',{attrs:{"transform":"rotate(-26 31.5 34)"}},[_c('path',{attrs:{"d":"M31.473 14.398l14.457 6.917 3.553 15.58-10.028 12.511-16.056.02-9.994-12.484 3.593-15.59z","fill":"#0a294a"}})]),_c('g',[_c('image',{attrs:{"xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAAnElEQVQ4ja3SMQ5AMBTG8YpbWC0O4yo2B5G4gNVotVjcwAEkBjEYiFh9Fk2aps9ry3/sa3+RlhCGAGwASmJWAjhMM9PmAUraTG3hoA7mKmJ9oqCWOMC16lDhCclOCWUfIdkoAEQ/YaH8uvwjFOv3NntCNfWilyO0c/+ada+QC2gFPVjIWIE19oApASVOkAL2GtR4QQrofk8caLPvBuJG1fMN7Y6mAAAAAElFTkSuQmCC","width":"19","height":"17","transform":"translate(23 25)"}})])])
          )
        }
      }
    